import { FC, useCallback, useContext } from 'react';

import { layoutContext } from '@context/layout';

import { faAngleDoubleLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './ToggleCollapseButton.module.scss';

const ToggleCollapseButton: FC<React.PropsWithChildren<unknown>> = () => {
  const { state: navState, dispatch: navDispatch } = useContext(layoutContext);

  const handleToggleSize = useCallback(() => {
    navDispatch({ type: 'TOGGLE_COLLAPSE', override: true });
  }, [navDispatch]);

  return (
    <button
      data-collapsed={navState.collapsed}
      className={styles['toggle-size-btn']}
      onClick={handleToggleSize}
    >
      <FontAwesomeIcon icon={faAngleDoubleLeft} fixedWidth />
    </button>
  );
};

export { ToggleCollapseButton };
